import { __assign, __extends } from "tslib";
import _ from 'lodash';
import React from 'react';
import s from './with-dimensions.scss';
export function withDimensions(Component) {
    var WithDimensions = /** @class */ (function (_super) {
        __extends(WithDimensions, _super);
        function WithDimensions() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.state = {
                width: 0,
                height: 0,
            };
            _this.container = React.createRef();
            _this.update = _.debounce(function () { return _this.setState({ width: _this.container.current.clientWidth, height: _this.container.current.clientHeight }); }, 250, { trailing: true, leading: false });
            _this.getWidth = function () { var _a; return (_a = _this.container.current) === null || _a === void 0 ? void 0 : _a.clientWidth; };
            _this.getHeight = function () { var _a; return (_a = _this.container.current) === null || _a === void 0 ? void 0 : _a.clientHeight; };
            return _this;
        }
        WithDimensions.prototype.componentDidMount = function () {
            window.addEventListener('resize', this.update);
            this.forceUpdate();
        };
        WithDimensions.prototype.componentWillUnmount = function () {
            window.removeEventListener('resize', this.update);
        };
        WithDimensions.prototype.componentDidUpdate = function () {
            if (this.state.width !== this.getWidth() || this.state.height !== this.getHeight()) {
                this.update();
            }
        };
        WithDimensions.prototype.render = function () {
            return (React.createElement("div", { className: s.container, ref: this.container },
                React.createElement(Component, __assign({}, this.props, { width: this.getWidth(), height: this.getHeight() }))));
        };
        return WithDimensions;
    }(React.Component));
    return WithDimensions;
}
//# sourceMappingURL=with-dimensions.js.map